import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Rectangle = styled.div`
  width: 100%;
  border: 0.5px solid ${({ theme }) => theme.color.gray};
  border-radius: 4px;
  padding: 22px 7px;
`;
